module.exports = __webpack_public_path__ + "static/image_insert_tabletpos.6cad0204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/za/integrations/images/tabletpos/image_insert_tabletpos.jpg
// module id = 1598
// module chunks = 189653833419725